/** @jsxImportSource @emotion/react */
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { css } from "@emotion/react";
import { RoundedActionLabel } from "../../../components/RoundedActionLabel";
import { MenuOverwriteSchedule, WeekDay } from "../models/Menus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { effects } from "../../../components/effects";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";
import { VerticalDivider } from "../../../components/VerticalDivider";
import { formatTimeRange } from "../../../util";

const scheduleWrapperStyle = css`
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 4px;
  margin-top: 4px;
`;

type Props = {
  schedule: MenuOverwriteSchedule;
  schedulesRemove?: (index: number) => void;
  index: number;
};

const additionalLabelStyle = css`
  box-shadow: ${effects.buttonPrimary};
`;

const contentWrapperStyle = css`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
`;

export const MenuOverwriteScheduleLabel = ({
  schedule,
  schedulesRemove,
  index,
}: Props) => {
  return (
    <div css={scheduleWrapperStyle}>
      <RoundedActionLabel
        label={
          WeekDay[schedule.dayOfWeek]
            ? WeekDay[schedule.dayOfWeek].toString()
            : ""
        }
        icon={
          <FontAwesomeIcon
            icon={solid("calendar-day")}
            color={colors.textPrimary}
          />
        }
        additionalStyles={additionalLabelStyle}
        buttonIcon={<FontAwesomeIcon icon={solid("xmark")} />}
        onButtonClick={
          schedulesRemove ? () => schedulesRemove(index) : undefined
        }
      >
        <div css={contentWrapperStyle}>
          <VerticalDivider height="16px" backgroundColor={colors.greyBorder} />
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textSecondary}
          >
            {formatTimeRange(schedule.startTime, schedule.endTime)}
          </StyledText>
        </div>
      </RoundedActionLabel>
    </div>
  );
};
